export class VUtils {
    static prettyPrintPercent(val) {
        return parseFloat((val * 100).toPrecision(3)).toLocaleString();
    }
    static prettyPrintRounded(val) {
        return parseFloat(val.toPrecision(3)).toLocaleString();
    }
    static sum(a, b) {
        return a + b;
    }
    static groupBy(list, keyGetter) {
        const map = new Map();
        list.forEach((item) => {
            const key = keyGetter(item);
            const collection = map.get(key);
            if (!collection) {
                map.set(key, [item]);
            }
            else {
                collection.push(item);
            }
        });
        return map;
    }
}
//# sourceMappingURL=utils.js.map